import {useEffect, useState} from "react";

export function useIsFullScreen() {
    const [isFullscreen, setIsFullscreen] = useState(false);

    const fullscreenChangeHandler = () => {
        setIsFullscreen(!!document.fullscreenElement);
    };

    useEffect(() => {
        document.addEventListener("fullscreenchange", fullscreenChangeHandler);
        document.addEventListener(
            "webkitfullscreenchange",
            fullscreenChangeHandler,
        );
        document.addEventListener(
            "mozfullscreenchange",
            fullscreenChangeHandler,
        );
        document.addEventListener(
            "MSFullscreenChange",
            fullscreenChangeHandler,
        );

        return () => {
            document.removeEventListener(
                "fullscreenchange",
                fullscreenChangeHandler,
            );
            document.removeEventListener(
                "webkitfullscreenchange",
                fullscreenChangeHandler,
            );
            document.removeEventListener(
                "mozfullscreenchange",
                fullscreenChangeHandler,
            );
            document.removeEventListener(
                "MSFullscreenChange",
                fullscreenChangeHandler,
            );
        };
    }, []);

    return isFullscreen;
}
